import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Search, Server, Network, Cloud, Target, ArrowUpRight } from 'lucide-react';
import { servicesData } from '../data/mock';

const ServicesSection = () => {
  const iconMap = {
    shield: Shield,
    scan: Search,
    server: Server,
    network: Network,
    cloud: Cloud,
    target: Target
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 }
    }
  };

  return (
    <section id="services" className="py-32 relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <span className="text-[#00ff88] text-sm font-medium uppercase tracking-wider mb-4 block">
            What I Do
          </span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            Security <span className="gradient-text">Services</span>
          </h2>
          <p className="text-white/50 text-lg max-w-2xl mx-auto">
            Comprehensive cybersecurity solutions to protect your digital assets and infrastructure from evolving threats.
          </p>
        </motion.div>

        {/* Services Grid */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {servicesData.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <motion.div
                key={service.id}
                variants={itemVariants}
                className="bento-card p-8 group cursor-pointer"
                whileHover={{ y: -5 }}
              >
                {/* Icon */}
                <div className="w-14 h-14 rounded-2xl bg-[#00ff88]/10 border border-[#00ff88]/20 flex items-center justify-center mb-6 group-hover:bg-[#00ff88]/20 group-hover:scale-110 transition-all duration-300">
                  {IconComponent && <IconComponent size={24} className="text-[#00ff88]" />}
                </div>

                {/* Content */}
                <h3 className="font-display text-xl font-semibold text-white mb-3 group-hover:text-[#00ff88] transition-colors">
                  {service.title}
                </h3>
                <p className="text-white/50 text-sm leading-relaxed">
                  {service.description}
                </p>

                {/* Arrow */}
                <div className="mt-6 flex items-center text-[#00ff88] opacity-0 group-hover:opacity-100 transition-opacity">
                  <span className="text-sm font-medium">Learn more</span>
                  <ArrowUpRight size={16} className="ml-1" />
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default ServicesSection;
